export const GIVING_FORM_PAGINATION_SCOPE = "giving-form";
